export class asyncRequest {
    constructor(base) {
        this.REQUEST = base + '_REQUEST'
        this.SUCCESS = base + '_SUCCESS'
        this.FAILURE = base + '_FAILURE'
    }
}
